import React from "react";
import PropTypes from "prop-types";
import { FallingLines } from "react-loader-spinner";
import { Navigate } from "react-router-dom";
import useCheckUser from "hooks/useCheckUser";
import { useSelector } from "react-redux";

import Sidebar from "components/sidebar";
import OnboardingForm from "pages/onboardingForm";
import useInitLoadLookups from "hooks/useInitLoadLookups";
import {
  STATUS_QUALIFIED,
  SUBSTATUS_ONBOARDING_REQUEST,
} from "utils/constantValues";

function GuardRoute({ children }) {
  const { isAuth, isChecked, user } = useCheckUser();

  useInitLoadLookups({ userId: user.id });

  const userDetails = useSelector((state) => state.userDetails || {});

  if (!isChecked || !userDetails.id) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <FallingLines
          color="#023A66"
          width="100%"
          visible={true}
          ariaLabel="falling-lines-loading"
        />
      </div>
    );
  }

  if (
    userDetails?.status === STATUS_QUALIFIED &&
    userDetails?.subStatus === SUBSTATUS_ONBOARDING_REQUEST
  ) {
    return (
      <div className="flex min-h-screen">
        <Sidebar isOnboarding={true} />
        <div className="flex-1 overflow-hidden">
          <OnboardingForm />;
        </div>
      </div>
    );
  }

  return isAuth ? (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 overflow-hidden">{children}</div>
    </div>
  ) : (
    <Navigate to="/login" />
  );
}

GuardRoute.propTypes = {
  children: PropTypes.any,
};
export default GuardRoute;
